import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';
const PAGE_SIZE = 20;

const STATUS_MAP = {
  completed: '完成', failed: '失败', pending: '等待', processing: '处理中', expired: '过期'
};

function AdminPayments() {
  const { session } = useAuth();
  const [payments, setPayments] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('');
  const [revenue, setRevenue] = useState(null);
  const [loading, setLoading] = useState(true);

  const totalPages = Math.ceil(total / PAGE_SIZE);

  const fetchPayments = useCallback(async () => {
    setLoading(true);
    try {
      const offset = (page - 1) * PAGE_SIZE;
      const params = new URLSearchParams({ limit: PAGE_SIZE, offset });
      if (statusFilter) params.set('status', statusFilter);
      const res = await fetch(`${API_BASE_URL}/admin/payments?${params}`, {
        headers: { 'Authorization': `Bearer ${session.access_token}` }
      });
      const result = await res.json();
      if (result.success) {
        setPayments(result.data.payments);
        setTotal(result.data.total);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [session, page, statusFilter]);

  const fetchRevenue = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/admin/revenue/stats`, {
        headers: { 'Authorization': `Bearer ${session.access_token}` }
      });
      const result = await res.json();
      if (result.success) setRevenue(result.data);
    } catch (e) { console.error(e); }
  }, [session]);

  useEffect(() => { fetchPayments(); }, [fetchPayments]);
  useEffect(() => { fetchRevenue(); }, [fetchRevenue]);

  const fmtMoney = (n) => `¥${(parseFloat(n) || 0).toFixed(2)}`;
  const fmtTime = (t) => new Date(t).toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

  return (
    <div>
      {/* 收入统计 */}
      {revenue && (
        <div className="ad-stats-grid" style={{ marginBottom: 20 }}>
          <div className="ad-stat-card">
            <div className="ad-stat-label">今日收入</div>
            <div className="ad-stat-value ad-stat-value--green">{fmtMoney(revenue.todayRevenue)}</div>
          </div>
          <div className="ad-stat-card">
            <div className="ad-stat-label">本周收入</div>
            <div className="ad-stat-value">{fmtMoney(revenue.weekRevenue)}</div>
          </div>
          <div className="ad-stat-card">
            <div className="ad-stat-label">本月收入</div>
            <div className="ad-stat-value">{fmtMoney(revenue.monthRevenue)}</div>
          </div>
          <div className="ad-stat-card">
            <div className="ad-stat-label">总收入</div>
            <div className="ad-stat-value">{fmtMoney(revenue.totalRevenue)}</div>
          </div>
        </div>
      )}

      {/* 支付订单列表 */}
      <div className="ad-term">
        <div className="ad-term-bar">
          <div className="ad-term-dots">
            <span className="ad-term-dot ad-term-dot--red" />
            <span className="ad-term-dot ad-term-dot--yellow" />
            <span className="ad-term-dot ad-term-dot--green" />
          </div>
          <span className="ad-term-title">payment_orders — {total} 条记录</span>
        </div>
        <div className="ad-term-body">
          <div className="ad-toolbar">
            <select className="ad-filter-select" value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
              <option value="">全部状态</option>
              <option value="pending">等待</option>
              <option value="processing">处理中</option>
              <option value="completed">完成</option>
              <option value="failed">失败</option>
              <option value="expired">过期</option>
            </select>
          </div>

          {loading ? (
            <div className="ad-loading">加载中...</div>
          ) : payments.length === 0 ? (
            <div className="ad-empty">暂无支付订单</div>
          ) : (
            <>
              <div className="ad-table-wrap">
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>用户</th>
                      <th>金额</th>
                      <th>方式</th>
                      <th>状态</th>
                      <th>时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map(p => (
                      <tr key={p.id}>
                        <td style={{ fontSize: 10 }}>{p.id.substring(0, 8)}</td>
                        <td>{p.user_email || p.user_id?.substring(0, 8)}</td>
                        <td>{fmtMoney(parseFloat(p.amount))}</td>
                        <td>{p.payment_method || '-'}</td>
                        <td><span className={`ad-badge ad-badge--${p.status}`}>{STATUS_MAP[p.status] || p.status}</span></td>
                        <td>{fmtTime(p.created_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="ad-pagination">
                  <button className="ad-page-btn" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>上一页</button>
                  <span className="ad-page-info">{page} / {totalPages}</span>
                  <button className="ad-page-btn" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>下一页</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminPayments;
